<div class="active-search-map-container">
  <div *ngIf="!centerCoordinates" class="map-unavailable p-4 text-center text-muted">
    <i class="bi bi-geo-alt display-6"></i>
    <p class="mb-0 mt-2">Indirizzo della richiesta non disponibile: impossibile centrare la mappa.</p>
  </div>

  <google-map *ngIf="centerCoordinates && mapOptions" height="480px" width="100%" [options]="mapOptions">
    <map-circle *ngIf="circleOptions" [options]="circleOptions"></map-circle>

    <map-advanced-marker
      *ngIf="centerCoordinates"
      [position]="centerCoordinates"
      [content]="centerMarkerPin"
      [title]="'Indirizzo della richiesta'"
      [zIndex]="1000">
    </map-advanced-marker>

    @for (marker of caregiverMapMarkers; track trackByCaregiverMarker($index, marker)) {
      <map-advanced-marker
        #caregiverMarkerRef="mapAdvancedMarker"
        [position]="marker.position"
        [content]="marker.pin"
        [title]="marker.record.fittingIndex.toFixed(0) + '% di compatibilità'"
        (mapClick)="caregiverInfoWindow.open(caregiverMarkerRef)">
        <map-info-window #caregiverInfoWindow="mapInfoWindow" [options]="caregiverInfoWindowOptions">
          <div class="caregiver-info-window">
            <app-caregiver-card
              [caregiverSelectionRecord]="marker.record"
              [isAddingCaregiver]="isAddingCaregiver"
              (selectedCard)="onAddToSelection(marker.record)">
            </app-caregiver-card>
          </div>
        </map-info-window>
      </map-advanced-marker>
    }

    @for (marker of alreadySelectedMapMarkers; track trackByCaregiverMarker($index, marker)) {
      <map-advanced-marker
        #alreadySelectedMarkerRef="mapAdvancedMarker"
        [position]="marker.position"
        [content]="marker.pin"
        [title]="'Già in candidatura'"
        (mapClick)="alreadySelectedInfoWindow.open(alreadySelectedMarkerRef)">
        <map-info-window #alreadySelectedInfoWindow="mapInfoWindow" [options]="caregiverInfoWindowOptions">
          <div class="caregiver-info-window">
            <app-caregiver-card
              [caregiverSelectionRecord]="marker.record"
              [isAddingCaregiver]="false"
              [alreadyInSelection]="true">
            </app-caregiver-card>
          </div>
        </map-info-window>
      </map-advanced-marker>
    }

    @for (marker of familyMapMarkers; track trackByFamilyMarker($index, marker)) {
      <map-advanced-marker
        #familyMarkerRef="mapAdvancedMarker"
        [position]="marker.position"
        [content]="marker.pin"
        [title]="'Servizio attivo: ' + marker.family.parentName + ' ' + marker.family.parentSurname"
        (mapClick)="familyInfoWindow.open(familyMarkerRef)">
        <map-info-window #familyInfoWindow="mapInfoWindow" [options]="familyInfoWindowOptions">
          <div class="family-info-window">
            <p class="fw-bold mb-1">{{ marker.family.parentName }} {{ marker.family.parentSurname }}</p>
            <p class="mb-1 text-muted"><i class="bi bi-geo-alt-fill"></i> {{ marker.family.distance | number:'1.1-1' }} km</p>
            <p class="mb-2 text-muted small">Apri la richiesta per vedere il caregiver assegnato.</p>
            <button type="button" class="btn btn-sm modalButtonAdd" (click)="openFamilyRequest.emit(marker.family)">
              <i class="bi bi-box-arrow-up-right me-1"></i>Apri richiesta
            </button>
          </div>
        </map-info-window>
      </map-advanced-marker>
    }
  </google-map>

  <p *ngIf="centerCoordinates" class="map-legend text-muted small mt-2 mb-0">
    <span class="legend-dot legend-center"></span> Indirizzo della richiesta
    <span class="legend-dot legend-caregiver ms-3"></span> Caregiver compatibili (colore/dimensione = indice di compatibilità)
    <span class="legend-dot legend-already-selected ms-3"></span> Caregiver già in candidatura
    <span class="legend-dot legend-family ms-3"></span> Famiglie con servizio attivo assegnato
  </p>
</div>
